<template>
  <div class="page home">
    <CollectionsPage
      :data="this.data"
      :language="'english'"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import CollectionsPage from "../components/CollectionsPage.vue";

import { mapMutations } from "vuex";

export default {
  name: "Home",
  components: { CollectionsPage },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.selectedLanguageMutation("En");
  },
  methods: {
    ...mapMutations(["selectedLanguageMutation"]),
  },
};
</script>
